export const getCategoryWithSlug = (param, values) => values.find((category) => {
  if (!category.slug) return false;
  return category.slug.split('__')[0] === param;
});

export const getQuerySlug = (params, categories) => {
  const category = getCategoryWithSlug(params[0], categories);
  if (!category) return null;
  if (params.length === 1) return category.slug;

  return getQuerySlug(params.slice(1), category.children);
};

export const parseCookie = (str) => str?.split(';').map((v) => v.split('=')).reduce((acc, v) => {
  acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
  return acc;
}, {});
